// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

const base64UrlDecode = (value: string): string | null => {
  try {
    const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
    const padding = normalized.length % 4 === 0 ? '' : '='.repeat(4 - (normalized.length % 4));
    const encoded = `${normalized}${padding}`;

    if (typeof atob === 'function') {
      return atob(encoded);
    }

    return null;
  } catch {
    return null;
  }
};

const readJwtPayload = (token: string): Record<string, unknown> | null => {
  const parts = token.split('.');
  if (parts.length < 2) {
    return null;
  }

  const decoded = base64UrlDecode(parts[1]);
  if (!decoded) {
    return null;
  }

  try {
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return null;
  }
};

export const isJwtExpired = (token: string | null | undefined, skewSeconds = 30): boolean => {
  const normalized = token?.trim();
  if (!normalized) {
    return false;
  }

  const payload = readJwtPayload(normalized);
  const exp = typeof payload?.exp === 'number' ? payload.exp : null;
  if (!exp) {
    return false;
  }

  const nowSeconds = Math.floor(Date.now() / 1000);
  return exp <= nowSeconds + skewSeconds;
};

export const getUsableJwt = (token: string | null | undefined, skewSeconds = 30): string | null => {
  const normalized = token?.trim();
  if (!normalized) {
    return null;
  }

  return isJwtExpired(normalized, skewSeconds) ? null : normalized;
};
